import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Column, Settings, DataTable } from '../../../../lib/ng-data-table';
import { getColumnsHeaders, mainAndSubHeaders, getColumnsPlayers } from '../columns';
import { HeaderDemoService } from '../header-demo.service';
import { Router, ActivatedRoute } from '@angular/router';
import { rsltTypeInTitle, rsltTypeInAPICall } from '../functions/title';
import { PagedResult } from 'lib/ng-crud-table';
import { DtMessages, DtMessagesEn } from '../../../../lib/dt-translate';


@Component({
  selector: 'app-header-demo',
  templateUrl: './header-demo.component.html',
  styleUrls: ['./header-demo.component.scss']
})
export class HeaderDemoComponent implements OnInit {
  @Input() rsltType: string;

  table: DataTable;
  columns: Column[];
  settings: Settings = new Settings({});

  title: string;
  @Output() childTitleEvent = new EventEmitter<string>();

  constructor(private _Activatedroute: ActivatedRoute, private _router: Router, private headerDemoService: HeaderDemoService) {
    //_Activatedroute.params.subscribe(val => {
    //  this.rsltType = _Activatedroute.snapshot.url[1].path;

      //this.setRsltType();
    //});

  }

  messages: DtMessages = new DtMessagesEn({
    titleDetailView: 'Player details',
    titleCreate: 'Create a new player'
  });

  ngOnInit() {
    this.setRsltType();
  }

  items: any[];
  LeftStartIndex: number;
  LeftEndIndex: number;
  RightStartIndex: number;
  RightEndIndex: number;
  
  getWidth(from: number, to: number) {
    let width = 0;
    for (let index = from; index < to; index++) {
      width += this.table.columns[index].width;
    }
    return width;
  }

  translate3d() {
    return `translate3d(${this.table.dimensions.offsetX * -1}px, 0, 0)`;
  }

  translate3dCell() {
    return `translate3d(${this.table.dimensions.offsetX}px, 0, 0)`;
  }

  setRsltType() {
    this.columns = getColumnsHeaders(this.rsltType, null);

    this.items = mainAndSubHeaders(this.rsltType, null).internal;
    this.LeftStartIndex = mainAndSubHeaders(this.rsltType, null).LeftStartIndex;
    this.LeftEndIndex = mainAndSubHeaders(this.rsltType, null).LeftEndIndex;
    this.RightStartIndex = mainAndSubHeaders(this.rsltType, null).RightStartIndex;
    this.RightEndIndex = mainAndSubHeaders(this.rsltType, null).RightEndIndex;

    this.title = rsltTypeInTitle(this.rsltType);
    this.childTitleEvent.emit(this.title);
    this.columns.splice(this.columns.length);
    this.table = new DataTable(this.columns, this.settings, this.messages, 0, 0, 0, [], this.rsltType, null, this.headerDemoService);
    this.table.events.onLoading(true);
    this.headerDemoService.getTotalRecords(rsltTypeInAPICall(this.rsltType)).subscribe(res => this.table.pager.total = res);
    this.headerDemoService.getItems(this.table.pager.perPage, this.table.pager.current, rsltTypeInAPICall(this.rsltType)).subscribe((res) => {
      const data = JSON.parse(res) as any[];
      this.table.rows = data;
      this.table.events.onLoading(false);
    });
  }

}
